import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'emotion'

import {
  itemRankingOffersRowsStyle, 
  itemRankingOffersPositionStyle, 
  itemRankingOffersCurrencyStyle,
  itemRankingOffersUserStyle, 
  itemRankingOffersTextPosition,
  itemRankingOffersTextCurrency, 
  itemRankingOffersTextUser,
  itemRankingOffersActiveStyle
} from './style';

const ItemRankingOffers = ({item, userOffer}) => {
  const { position, price, name } = item

  return(
    !userOffer ? (
      <div className={css`${itemRankingOffersRowsStyle()}`}>
        <div className={css`${itemRankingOffersPositionStyle(1)}`}>
          <span className={css`${itemRankingOffersTextPosition}`}>{position}º</span>
        </div>
        <div className={css`${itemRankingOffersCurrencyStyle(4)}`}>
          <span className={css`${itemRankingOffersTextCurrency}`}>R$ {price}</span>
        </div>
        <div className={css`${itemRankingOffersUserStyle(3)}`}>
          <span>{name}</span>
        </div>
      </div>
    ) : (
      <div className={css`${itemRankingOffersRowsStyle(userOffer)}`}>
        <div className={css`${itemRankingOffersPositionStyle(1)}`}>
          <span className={css`${itemRankingOffersTextPosition}`}>{position}º</span>
        </div>
        <div className={css`${itemRankingOffersActiveStyle(7)}`}>
          <span className={css`${itemRankingOffersTextCurrency}`}>R$ {price}</span>
          <span className={css`${itemRankingOffersTextUser}`}>Esta será sua posição</span>
        </div>
      </div>
    )
  )
}

ItemRankingOffers.propTypes = {
  item: PropTypes.object.isRequired,
  userOffer: PropTypes.bool
}

ItemRankingOffers.defaultProps = {
  userOffer: false
}

export default ItemRankingOffers